<template>
  <div class="app-container">
    <div class="page-title">
      <h2>{{ $t('recolte.recoltes') }}</h2>
    </div>
    <el-card v-if="checkRole(['admin'])" class="box-card filter-card just-for-admin">
      <div slot="header" class="clearfix">
        <span>{{ $t('general.filter') }}</span>
        <el-button style="float: right; padding: 3px 0" type="text" @click="initSearch">{{ $t('general.init') }}</el-button>
      </div>
      <div class="filter-container" style="display: flex; justify-content: space-between; align-items: center;">
        <div>
          <el-button class="mr-15 filter-item" type="success" icon="el-icon-search" @click="handleSearchSac">
            Rechercher un sac
          </el-button>
          <el-radio label="corbeille" class="danger-radio" border>{{ $t('general.corbeille') }}</el-radio>
        </div>
        <div style="display: flex; gap: 10px;">
          <el-button class="filter-item" type="default" @click="handleFilterCI">
            CI
          </el-button>
          <el-button class="filter-item" type="default" @click="handleFilterSCOPS">
            SCOOPS
          </el-button>
          <el-button class="filter-item" type="default" @click="handleFilterUniteProduction">
            UNITE DE PRODUCTION
          </el-button>
          <el-button class="filter-item" type="default" @click="handleFilterGroupement">
            GROUPEMENT
          </el-button>
        </div>
      </div>
      <hr>
      <div style="display:flex; flex-direction:row">
        <el-select
          v-model="campagneFilter"
          placeholder="Campagne"
          style="margin-right:10px; width:200px"
          @change="filterByCampagne(campagneFilter)"
        >
          <el-option
            v-for="(item, index) in campagnes"
            :key="index"
            :label="item.periode"
            :value="index"
          />
        </el-select>
      </div>
    </el-card>

    <el-card class="box-card">
      <div class="filter-container">
        <el-input v-model="query.keyword" :placeholder="$t('general.keyword')" class="wd-200 mr-15 filter-item" @keyup.enter.native="handleFilterRecoltes" />
        <el-button v-waves class="mr-15 filter-item" type="primary" icon="el-icon-search" @click="handleFilterRecoltes">
          {{ $t('general.search') }}
        </el-button>
        <el-button v-waves :loading="downloading" class="filter-item" type="primary" icon="el-icon-download" @click="handleDownload">
          {{ $t('general.export') }}
        </el-button>
        <!-- <el-button v-if="checkPermission(['creer recolte'])" class="mr-15 filter-item" type="primary" icon="el-icon-plus" @click="handlecreateRecolte">
          {{ $t('general.add') }}
        </el-button> -->
      </div>
      <el-table v-loading="loading" :data="list" border fit highlight-current-row style="width: 100%">
        <el-table-column align="center" label="Code" width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.code }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('recolte.date')">
          <template slot-scope="scope">
            <span>{{ scope.row.date_recolte_libelle }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('producteur.producteur')">
          <template slot-scope="scope">
            <span>{{ scope.row.producteur }}</span>
          </template>

        </el-table-column>
        <el-table-column align="center" :label="$t('parcelle.superficie')">
          <template slot-scope="scope">
            <span>{{ scope.row.parcelle.superficie }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('sacs.nombreSacs')">
          <template slot-scope="scope">
            <span>{{ scope.row.nbrs_sac }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('recolte.poidsTotal')">
          <template slot-scope="scope">
            <span>{{ scope.row.poids_total }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" :label="$t('recolte.commentaire')">
          <template slot-scope="scope">
            <span>{{ scope.row.commentaire }}</span>
          </template>
        </el-table-column>

        <!-- <el-table-column align="center" :label="$t('recolte.recolte')">
          <template slot-scope="scope">
            <div class="flex flex-wrap gap-2 my-2">
              <el-tag v-if="!scope.row.recolte_cloturee" type="danger" class="mx-1" effect="light" round>EN COURS</el-tag>
              <el-tag v-if="scope.row.recolte_cloturee" type="success" class="mx-1" effect="light" round>CLÔTURÉE</el-tag>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column align="center" :label="$t('general.actions')">
          <template slot-scope="scope">
            <el-button type="info" size="small" icon="el-icon-view" @click="getRecolteLink(scope.row.id)" />
          </template>
        </el-table-column>
      </el-table>
      <pagination v-if="total > 0" :total="total" :page.sync="query.page" :limit.sync="query.limit" @pagination="getRecoltesList" />
      <!-- ======= REGION USER DIALOG ======= -->
      <el-dialog
        :title="editing ? $t('recolte.edit') + ' ' + currentRecolte.libelle : $t('recolte.AddRecolte')"
        :visible.sync="dialogCreateRecolte"
        :before-close="handleCloseCampagneagricoleCreateDraw"
        :loading="recolteCreating"
        width="30%"
      >
        <div class="content-inputs">
          <el-form ref="recolteForm" :rules="rules" :model="currentRecolte" label-position="left">
            <div class="ligne">
              <el-form-item :label="$t('recolte.recolte')" prop="recolte_id">
                <el-select v-model="currentRecolte.recolte_id" class="filter-item" :placeholder="$t('recolte.recolte')" style="width: 100%;" prop="recolte_id">
                  <el-option
                    v-for="(recolte, idex) in recoltes"
                    :key="idex"
                    :label="recolte.libelle | uppercaseFirst"
                    :value="recolte.id"
                    :disabled="!recolte.is_active"
                  />
                </el-select>
              </el-form-item>
              <el-button class="bouton" type="primary" :icon="dialogCreateRecolte ? 'el-icon-minus' : 'el-icon-plus'" circle @click="dialogCreateRecolte=!dialogCreateRecolte" />
            </div>
            <el-form-item :label="$t('general.libelle')" prop="libelle">
              <el-input v-model="currentRecolte.libelle" />
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="dialogCreateRecolte=false">
              {{ $t('permission.cancel') }}
            </el-button>
            <el-button type="primary" :loading="recolteCreating" @click="editing ? updateRecolte() : createRecolte()">
              {{ recolteCreating ? $t('general.saving') : $t('general.save') }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <el-dialog
        :title="$t('Rechercher un sac')"
        :visible.sync="sacSearch.dialogSearchSac"
        :before-close="handleCloseCampagneagricoleCreateDraw"
        :loading="sacSearch.sacSearching"
        width="30%"
      >
        <div class="content-inputs">
          <el-form ref="sacForm" :rules="rules" :model="sacSearch.keyword" label-position="left">
            <el-form-item :label="$t('Code du sac')" prop="code">
              <el-input v-model="sacSearch.keyword.code" />
            </el-form-item>
            <el-alert
              v-show="sacSearch.sacSearchError"
              :title="sacSearch.sacSearchMessage"
              :closable="false"
              type="error"
              show-icon
            />
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="sacSearch.dialogSearchSac=false">
              {{ $t('permission.cancel') }}
            </el-button>
            <el-button type="primary" :loading="sacSearch.sacSearching" @click="getSacDetail()">
              Rechercher
            </el-button>
          </div>
        </span>
      </el-dialog>

      <el-dialog
        :title="$t('Informations sur le sac')"
        :visible.sync="sacSearch.dialogSacInfo"
        :before-close="handleCloseCampagneagricoleCreateDraw"
        :loading="sacSearch.sacSearching"
        width="60%"
      >
        <div v-if="currentSac.code" class="dialog-body">
          <el-col :span="40">
            <el-card shadow="never">
              <el-col :span="6" align="center">
                <div class="text item">
                  <el-avatar shape="square" :size="100" src="https://res.cloudinary.com/dwj6sdjxn/image/upload/v1669370400/fertilizer_2_amfrld.png" />
                </div>
              </el-col>
              <el-col :span="8">
                <el-tag size="large" type="info" effect="plain"><span style="font-weight:bold; font-size:medium">{{ currentSac.code+ ' / ' + currentSac.poids + ' Kg ' }}</span></el-tag>&nbsp;
                <el-tag size="large" type="success"><span style="font-weight:bold"><a @click="getRecolteLink(currentSac.recolte.id)">{{ 'COLLECTE : ' + currentSac.recolte.code }}</a></span></el-tag>
                <el-tag size="large" type="success"><span style="font-weight:bold"><a @click="getParcelleLink(currentSac.recolte.parcelle.id)">{{ 'PARCELLE : ' + currentSac.recolte.parcelle.code }}</a></span></el-tag>
                <el-tag v-if="currentSac.lot" size="large" type="success"><span style="font-weight:bold"><a @click="getLotLink(currentSac.lot.id)">{{ 'LOT : ' + currentSac.lot.code }}</a></span></el-tag>
              </el-col>
              <el-col :span="8">
                <el-tag
                  size="large"
                  type="info"
                  class="mx-1"
                  effect="plain"
                >
                  <span style="font-weight:bold; font-size:medium">PRODUCTEUR</span>
                </el-tag>&nbsp;
                <el-tag size="large" effect="light" type="success"><span style="font-weight:bold"><a @click="getProducteurLink(currentSac.producteur.id)">{{ 'Code : ' + currentSac.producteur.code }}</a></span></el-tag>
                <el-tag size="large" effect="light" type="success"><span style="font-weight:bold"><a @click="getProducteurLink(currentSac.producteur.id)">Nom : {{ currentSac.producteur.nom.toUpperCase() +' '+ currentSac.producteur.prenom.charAt(0).toUpperCase() + currentSac.producteur.prenom.slice(1) }}</a></span></el-tag>
                <el-tag size="large" effect="light" type="success"><span style="font-weight:bold"><a @click="getGroupementLink(currentSac.producteur.groupement_id)">Groupement : {{ currentSac.producteur.groupement.nom.charAt(0).toUpperCase() + currentSac.producteur.groupement.nom.slice(1) }}</a></span></el-tag>
                <el-tag size="large" effect="light" type="success"><span style="font-weight:bold"><a @click="getUniteProductionLink(currentSac.producteur.groupement.unite_production_id)">Unité de production : {{ currentSac.producteur.groupement.unite_production.nom.charAt(0).toUpperCase() + currentSac.producteur.groupement.unite_production.nom.slice(1) }}</a></span></el-tag>
              </el-col>
            </el-card>
          </el-col>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="sacSearch.dialogSacInfo=false">
              {{ $t('permission.cancel') }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <el-dialog
        :title="$t('recolte.AddRecolte')"
        :visible.sync="dialogCreateRecolte"
        :before-close="handleCloseCampagneagricoleCreateDraw"
        :loading="recolteCreating"
        width="30%"
      >
        <div class="content-inputs">
          <el-form ref="recolteForm" :rules="rules" :model="currentRecolte" label-position="left">
            <el-form-item :label="$t('recolte.libelle')" prop="libelle">
              <el-input v-model="currentRecolte.libelle" />
            </el-form-item>
            <el-form-item :label="$t('general.description')" prop="description">
              <el-input v-model="currentRecolte.description" type="textarea" />
            </el-form-item>
          </el-form>
          <el-radio-group v-model="ci" size="medium">
            <el-radio-button :label="'audit'">Audit</el-radio-button>
            <el-radio-button :label="'ci'">Contrôle interne</el-radio-button>
          </el-radio-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <div style="text-align:right;">
            <el-button plain type="danger" @click="dialogCreateRecolte=false">
              {{ $t('permission.cancel') }}
            </el-button>
            <el-button type="primary" :loading="recolteCreating" @click="editing ? updateRecolte() : createRecolte()">
              {{ recolteCreating ? $t('general.saving') : $t('general.save') }}
            </el-button>
          </div>
        </span>
      </el-dialog>

      <!-- Dialogue Filtre par CI -->
      <el-dialog
        :title="`Filtre par Contrôleur Interne (CI) | Quantité Total collectée : ${formatNumber(totalQuantiteCollectee)} t`"
        :visible.sync="dialogFilterCI"
        width="80%"
      >
        <div style="margin-bottom: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <el-input
              v-model="ciSearchKeyword"
              placeholder="Rechercher par nom..."
              prefix-icon="el-icon-search"
              clearable
              style="width: 300px;"
            />
            <div style="display: flex; align-items: center; gap: 10px;">
              <span style="font-weight: 500; color: #606266; margin-right: 8px;">📅 Période:</span>
              <el-radio-group v-model="ciPeriode.type" size="small" @change="handleCIPeriodeChange">
                <el-radio-button label="journalier">Journalier</el-radio-button>
                <el-radio-button label="hebdo">Hebdo</el-radio-button>
                <el-radio-button label="campagne">Campagne</el-radio-button>
                <el-radio-button label="custom">Personnalisé</el-radio-button>
              </el-radio-group>
              <div
                style="margin-left: 10px; color: #606266; font-size: 14px;"
              >
                <b>Période sélectionnée :</b> {{ ciPeriodeDisplay }}
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
          <div
            v-if="ciPeriode.type === 'custom'"
            style="display: flex; align-items: center; gap: 10px; margin-top: 10px;"
          >
            <el-date-picker
              v-model="ciPeriode.date_debut"
              type="date"
              placeholder="Date début"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 180px;"
              @change="handleCIDateChange"
            />
            <el-date-picker
              v-model="ciPeriode.date_fin"
              type="date"
              placeholder="Date fin"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 180px;"
              @change="handleCIDateChange"
            />
          </div>
        </div>
        <el-table
          v-loading="loadingCI"
          :data="filteredCIList"
          border
          fit
          highlight-current-row
          style="width: 100%"
          @row-click="(row) => applyCIFilter(row.id)"
        >
          <el-table-column align="center" label="Nom" min-width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.nom }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Quantité collectée (t)" min-width="150">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.quantite_collectee_tonnes) }} t</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Nombre de sacs" min-width="120">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.nombre_sacs) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Nombre de collectes" min-width="150">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.nombre_collectes) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Superficie (ha)" min-width="140">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.superficie_ha) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="%" min-width="100">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.percentage) }}%</span>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-if="filteredCIListTotal > 0"
          :total="filteredCIListTotal"
          :page.sync="ciPagination.page"
          :limit.sync="ciPagination.limit"
          :page-sizes="[50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
        />

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFilterCI = false">Fermer</el-button>
          <el-button type="primary" @click="clearCIFilter">Réinitialiser</el-button>
        </span>
      </el-dialog>

      <!-- Dialogue Filtre par SCOOPS -->
      <el-dialog
        :title="`Filtre par SCOOPS | Quantité Total collectée : ${formatNumber(totalQuantiteCollecteeSCOPS)} t`"
        :visible.sync="dialogFilterSCOPS"
        width="80%"
      >
        <div style="margin-bottom: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <el-input
              v-model="scopsSearchKeyword"
              placeholder="Rechercher par nom..."
              prefix-icon="el-icon-search"
              clearable
              style="width: 300px;"
            />
            <div style="display: flex; align-items: center; gap: 10px;">
              <span style="font-weight: 500; color: #606266; margin-right: 8px;">📅 Période:</span>
              <el-radio-group v-model="scopsPeriode.type" size="small" @change="handleSCOPSPeriodeChange">
                <el-radio-button label="journalier">Journalier</el-radio-button>
                <el-radio-button label="hebdo">Hebdo</el-radio-button>
                <el-radio-button label="campagne">Campagne</el-radio-button>
                <el-radio-button label="custom">Personnalisé</el-radio-button>
              </el-radio-group>
              <div
                style="margin-left: 10px; color: #606266; font-size: 14px;"
              >
                <b>Période sélectionnée :</b> {{ scopsPeriodeDisplay }}
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
          <div
            v-if="scopsPeriode.type === 'custom'"
            style="display: flex; align-items: center; gap: 10px; margin-top: 10px;"
          >
            <el-date-picker
              v-model="scopsPeriode.date_debut"
              type="date"
              placeholder="Date début"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 180px;"
              @change="handleSCOPSDateChange"
            />
            <el-date-picker
              v-model="scopsPeriode.date_fin"
              type="date"
              placeholder="Date fin"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 180px;"
              @change="handleSCOPSDateChange"
            />
          </div>
        </div>
        <el-table
          v-loading="loadingSCOPS"
          :data="filteredSCOPSList"
          border
          fit
          highlight-current-row
          style="width: 100%"
          @row-click="(row) => applySCOPSFilter(row.id)"
        >
          <el-table-column align="center" label="Nom" min-width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.nom }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Quantité collectée (t)" min-width="150">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.quantite_collectee_tonnes) }} t</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Nombre de sacs" min-width="120">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.nombre_sacs) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Nombre de collectes" min-width="150">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.nombre_collectes) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Superficie (ha)" min-width="140">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.superficie_ha) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="%" min-width="100">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.percentage) }}%</span>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-if="filteredSCOPSListTotal > 0"
          :total="filteredSCOPSListTotal"
          :page.sync="scopsPagination.page"
          :limit.sync="scopsPagination.limit"
          :page-sizes="[50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
        />

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFilterSCOPS = false">Fermer</el-button>
          <el-button type="primary" @click="clearSCOPSFilter">Réinitialiser</el-button>
        </span>
      </el-dialog>

      <!-- Dialogue Filtre par Unité de Production -->
      <el-dialog
        :title="`Filtre par Unité de Production | Quantité Total collectée : ${formatNumber(totalQuantiteCollecteeUniteProduction)} t`"
        :visible.sync="dialogFilterUniteProduction"
        width="80%"
      >
        <div style="margin-bottom: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <el-input
              v-model="uniteProductionSearchKeyword"
              placeholder="Rechercher par nom..."
              prefix-icon="el-icon-search"
              clearable
              style="width: 300px;"
            />
            <div style="display: flex; align-items: center; gap: 10px;">
              <span style="font-weight: 500; color: #606266; margin-right: 8px;">📅 Période:</span>
              <el-radio-group v-model="uniteProductionPeriode.type" size="small" @change="handleUniteProductionPeriodeChange">
                <el-radio-button label="journalier">Journalier</el-radio-button>
                <el-radio-button label="hebdo">Hebdo</el-radio-button>
                <el-radio-button label="campagne">Campagne</el-radio-button>
                <el-radio-button label="custom">Personnalisé</el-radio-button>
              </el-radio-group>
              <div
                style="margin-left: 10px; color: #606266; font-size: 14px;"
              >
                <b>Période sélectionnée :</b> {{ uniteProductionPeriodeDisplay }}
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
          <div
            v-if="uniteProductionPeriode.type === 'custom'"
            style="display: flex; align-items: center; gap: 10px; margin-top: 10px;"
          >
            <el-date-picker
              v-model="uniteProductionPeriode.date_debut"
              type="date"
              placeholder="Date début"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 180px;"
              @change="handleUniteProductionDateChange"
            />
            <el-date-picker
              v-model="uniteProductionPeriode.date_fin"
              type="date"
              placeholder="Date fin"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 180px;"
              @change="handleUniteProductionDateChange"
            />
          </div>
        </div>
        <el-table
          v-loading="loadingUniteProduction"
          :data="filteredUniteProductionList"
          border
          fit
          highlight-current-row
          style="width: 100%"
          @row-click="(row) => applyUniteProductionFilter(row.id)"
        >
          <el-table-column align="center" label="Nom" min-width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.nom }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Quantité collectée (t)" min-width="150">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.quantite_collectee_tonnes) }} t</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Nombre de sacs" min-width="120">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.nombre_sacs) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Nombre de collectes" min-width="150">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.nombre_collectes) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Superficie (ha)" min-width="140">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.superficie_ha) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="%" min-width="100">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.percentage) }}%</span>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-if="filteredUniteProductionListTotal > 0"
          :total="filteredUniteProductionListTotal"
          :page.sync="uniteProductionPagination.page"
          :limit.sync="uniteProductionPagination.limit"
          :page-sizes="[50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
        />

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFilterUniteProduction = false">Fermer</el-button>
          <el-button type="primary" @click="clearUniteProductionFilter">Réinitialiser</el-button>
        </span>
      </el-dialog>

      <!-- Dialogue Filtre par Groupement -->
      <el-dialog
        :title="`Filtre par Groupement | Quantité Total collectée : ${formatNumber(totalQuantiteCollecteeGroupement)} t`"
        :visible.sync="dialogFilterGroupement"
        width="80%"
      >
        <div style="margin-bottom: 20px;">
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <el-input
              v-model="groupementSearchKeyword"
              placeholder="Rechercher par nom..."
              prefix-icon="el-icon-search"
              clearable
              style="width: 300px;"
            />
            <div style="display: flex; align-items: center; gap: 10px;">
              <span style="font-weight: 500; color: #606266; margin-right: 8px;">📅 Période:</span>
              <el-radio-group v-model="groupementPeriode.type" size="small" @change="handleGroupementPeriodeChange">
                <el-radio-button label="journalier">Journalier</el-radio-button>
                <el-radio-button label="hebdo">Hebdo</el-radio-button>
                <el-radio-button label="campagne">Campagne</el-radio-button>
                <el-radio-button label="custom">Personnalisé</el-radio-button>
              </el-radio-group>
              <div
                style="margin-left: 10px; color: #606266; font-size: 14px;"
              >
                <b>Période sélectionnée :</b> {{ groupementPeriodeDisplay }}
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end; margin-bottom: 10px;">
          <div
            v-if="groupementPeriode.type === 'custom'"
            style="display: flex; align-items: center; gap: 10px; margin-top: 10px;"
          >
            <el-date-picker
              v-model="groupementPeriode.date_debut"
              type="date"
              placeholder="Date début"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 180px;"
              @change="handleGroupementDateChange"
            />
            <el-date-picker
              v-model="groupementPeriode.date_fin"
              type="date"
              placeholder="Date fin"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              size="small"
              style="width: 180px;"
              @change="handleGroupementDateChange"
            />
          </div>
        </div>
        <el-table
          v-loading="loadingGroupement"
          :data="filteredGroupementList"
          border
          fit
          highlight-current-row
          style="width: 100%"
          @row-click="(row) => applyGroupementFilter(row.id)"
        >
          <el-table-column align="center" label="Nom" min-width="200">
            <template slot-scope="scope">
              <span>{{ scope.row.nom }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Quantité collectée (t)" min-width="150">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.quantite_collectee_tonnes) }} t</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Nombre de sacs" min-width="120">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.nombre_sacs) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Nombre de collectes" min-width="150">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.nombre_collectes) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="Superficie (ha)" min-width="140">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.superficie_ha) }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="%" min-width="100">
            <template slot-scope="scope">
              <span>{{ formatNumber(scope.row.percentage) }}%</span>
            </template>
          </el-table-column>
        </el-table>

        <pagination
          v-if="filteredGroupementListTotal > 0"
          :total="filteredGroupementListTotal"
          :page.sync="groupementPagination.page"
          :limit.sync="groupementPagination.limit"
          :page-sizes="[50, 100, 200]"
          layout="total, sizes, prev, pager, next, jumper"
        />

        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogFilterGroupement = false">Fermer</el-button>
          <el-button type="primary" @click="clearGroupementFilter">Réinitialiser</el-button>
        </span>
      </el-dialog>

      <!-- ======= REGION USER DIALOG ======= -->

    </el-card>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'; // Pagination
import Resource from '@/api/resource';
import waves from '@/directive/waves'; // Directives
import permission from '@/directive/permission'; //  directive Permission
import role from '@/directive/role'; // Directives Role
import checkPermission from '@/utils/permission'; // Vérification Permission
import checkRole from '@/utils/role'; // Vérification Roles
import moment from 'moment';
// const recolteResource = new Resource('recoltes');
const recolteResource = new Resource('recoltes');
const recolteWebResource = new Resource('recoltes-web');
const recolteCIStatsResource = new Resource('recoltes-ci-statistics');
const recolteUniteProductionStatsResource = new Resource('recoltes-unite-production-statistics');
const recolteGroupementStatsResource = new Resource('recoltes-groupement-statistics');
const recolteSCOPSStatsResource = new Resource('recoltes-scoops-statistics');
const campagneagricoleResource = new Resource('campagne_agricoles');

const sacResource = new Resource('sacs/info');
export default {
  name: 'RecoltesList',
  components: { Pagination },
  directives: { waves, permission, role },
  data() {
    return {
      recoltes: [],
      libelleRecolte: [],
      ci: '',
      list: null,
      total: 0,
      loading: true,
      downloading: false,
      recolteCreating: false,
      campagneFilter: null,
      campagnes: null,
      // recolteCreating: false,
      currentRecolte: {},
      sacSearch: {
        keyword: { code: '' },
        sacSearching: false,
        dialogSacInfo: false,
        dialogSearchSac: false,
        sacSearchError: false,
        sacSearchMessage: '',
      },
      currentSac: {},
      editing: false,
      // currentRecolte: {},
      query: {
        page: 1,
        limit: 15,
        keyword: '',
        campagne_agricole_id: null,
      },
      queryfiltre: {
        page: 1,
        limit: 15,
        keyword: '',
      },
      dialogCreateRecolte: false,
      // dialogCreateRecolte: false,
      currentRecolteId: 0,
      dialogFilterCI: false,
      loadingCI: false,
      ciList: [],
      ciSearchKeyword: '',
      selectedCIId: null,
      ciPeriode: {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      },
      ciPagination: {
        page: 1,
        limit: 50,
      },
      dialogFilterSCOPS: false,
      loadingSCOPS: false,
      scopsList: [],
      scopsSearchKeyword: '',
      selectedSCOPSId: null,
      scopsPeriode: {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      },
      scopsPagination: {
        page: 1,
        limit: 50,
      },
      dialogFilterUniteProduction: false,
      loadingUniteProduction: false,
      uniteProductionList: [],
      uniteProductionSearchKeyword: '',
      selectedUniteProductionId: null,
      uniteProductionPeriode: {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      },
      uniteProductionPagination: {
        page: 1,
        limit: 50,
      },
      dialogFilterGroupement: false,
      loadingGroupement: false,
      groupementList: [],
      groupementSearchKeyword: '',
      selectedGroupementId: null,
      groupementPeriode: {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      },
      groupementPagination: {
        page: 1,
        limit: 50,
        total: 0,
      },
      rules: {
        libelle: [{ required: true, message: this.$t('recolte.LibelleRequired'), trigger: 'blur' }],
        code: [{ required: true, message: this.$t('code Required'), trigger: 'blur' }],
        recolte_id: [{ required: true, message: this.$t('recolte.RecolteRequired'), trigger: 'blur' }],
      },
      fileList: [],
    };
  },
  computed: {
    filteredCIList() {
      let filtered = this.ciList;

      // Appliquer le filtre de recherche
      if (this.ciSearchKeyword && this.ciSearchKeyword.trim() !== '') {
        const keyword = this.ciSearchKeyword.toLowerCase().trim();
        filtered = this.ciList.filter(ci => {
          return ci.nom && ci.nom.toLowerCase().includes(keyword);
        });
      }

      // Appliquer la pagination
      const start = (this.ciPagination.page - 1) * this.ciPagination.limit;
      const end = start + this.ciPagination.limit;
      return filtered.slice(start, end);
    },
    filteredCIListTotal() {
      let filtered = this.ciList;

      // Appliquer le filtre de recherche pour calculer le total
      if (this.ciSearchKeyword && this.ciSearchKeyword.trim() !== '') {
        const keyword = this.ciSearchKeyword.toLowerCase().trim();
        filtered = this.ciList.filter(ci => {
          return ci.nom && ci.nom.toLowerCase().includes(keyword);
        });
      }

      return filtered.length;
    },
    ciPeriodeDisplay() {
      const periode = this.ciPeriode || {};
      const type = periode.type || '';
      if (!type) {
        return 'Non défini';
      }

      if (type === 'hebdo') {
        const dateReference = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const { start, end, weekNumber } = this.getWeekRange(dateReference);
        const weekLabel = weekNumber ? `Semaine ${weekNumber}` : 'Semaine non définie';
        const formattedStart = this.formatDisplayDate(start);
        const formattedEnd = this.formatDisplayDate(end);
        if (formattedStart && formattedEnd) {
          return `${weekLabel} (${formattedStart} - ${formattedEnd})`;
        }
        return `${weekLabel}`;
      }

      if (type === 'journalier') {
        const referenceDate = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const formattedDate = this.formatDisplayDate(referenceDate);
        if (formattedDate) {
          return `${formattedDate}`;
        }
        return 'Journalier';
      }

      if (type === 'custom') {
        const formattedStart = this.formatDisplayDate(periode.date_debut);
        const formattedEnd = this.formatDisplayDate(periode.date_fin);
        if (formattedStart && formattedEnd) {
          return `Personnalisé - ${formattedStart} - ${formattedEnd}`;
        }
        if (formattedStart || formattedEnd) {
          return `Personnalisé - ${formattedStart || formattedEnd}`;
        }
        return 'Personnalisé';
      }

      if (type === 'campagne') {
        const campagneId = this.getCurrentCampagneId();
        if (campagneId) {
          const campagne = this.campagnes?.find(c => c.id === campagneId);
          const campLabel = campagne?.periode || null;
          if (campLabel) {
            return `${campLabel} (ID ${campagneId})`;
          }
          return `Campagne en cours (ID ${campagneId})`;
        }
        return 'Campagne';
      }

      return type;
    },
    totalQuantiteCollectee() {
      if (!this.ciList || this.ciList.length === 0) {
        return 0;
      }
      return this.ciList.reduce((total, ci) => {
        const quantite = Number(ci.quantite_collectee_tonnes) || 0;
        return total + quantite;
      }, 0);
    },
    filteredUniteProductionList() {
      let filtered = this.uniteProductionList;

      // Appliquer le filtre de recherche
      if (this.uniteProductionSearchKeyword && this.uniteProductionSearchKeyword.trim() !== '') {
        const keyword = this.uniteProductionSearchKeyword.toLowerCase().trim();
        filtered = this.uniteProductionList.filter(up => {
          return up.nom && up.nom.toLowerCase().includes(keyword);
        });
      }

      // Appliquer la pagination
      const start = (this.uniteProductionPagination.page - 1) * this.uniteProductionPagination.limit;
      const end = start + this.uniteProductionPagination.limit;
      return filtered.slice(start, end);
    },
    filteredUniteProductionListTotal() {
      let filtered = this.uniteProductionList;

      // Appliquer le filtre de recherche pour calculer le total
      if (this.uniteProductionSearchKeyword && this.uniteProductionSearchKeyword.trim() !== '') {
        const keyword = this.uniteProductionSearchKeyword.toLowerCase().trim();
        filtered = this.uniteProductionList.filter(up => {
          return up.nom && up.nom.toLowerCase().includes(keyword);
        });
      }

      return filtered.length;
    },
    uniteProductionPeriodeDisplay() {
      const periode = this.uniteProductionPeriode || {};
      const type = periode.type || '';
      if (!type) {
        return 'Non défini';
      }

      if (type === 'hebdo') {
        const dateReference = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const { start, end, weekNumber } = this.getWeekRange(dateReference);
        const weekLabel = weekNumber ? `Semaine ${weekNumber}` : 'Semaine non définie';
        const formattedStart = this.formatDisplayDate(start);
        const formattedEnd = this.formatDisplayDate(end);
        if (formattedStart && formattedEnd) {
          return `${weekLabel} (${formattedStart} - ${formattedEnd})`;
        }
        return `${weekLabel}`;
      }

      if (type === 'journalier') {
        const referenceDate = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const formattedDate = this.formatDisplayDate(referenceDate);
        if (formattedDate) {
          return `${formattedDate}`;
        }
        return 'Journalier';
      }

      if (type === 'custom') {
        const formattedStart = this.formatDisplayDate(periode.date_debut);
        const formattedEnd = this.formatDisplayDate(periode.date_fin);
        if (formattedStart && formattedEnd) {
          return `Personnalisé - ${formattedStart} - ${formattedEnd}`;
        }
        if (formattedStart || formattedEnd) {
          return `Personnalisé - ${formattedStart || formattedEnd}`;
        }
        return 'Personnalisé';
      }

      if (type === 'campagne') {
        const campagneId = this.getCurrentCampagneId();
        if (campagneId) {
          const campagne = this.campagnes?.find(c => c.id === campagneId);
          const campLabel = campagne?.periode || null;
          if (campLabel) {
            return `${campLabel} (ID ${campagneId})`;
          }
          return `Campagne en cours (ID ${campagneId})`;
        }
        return 'Campagne';
      }

      return type;
    },
    totalQuantiteCollecteeUniteProduction() {
      if (!this.uniteProductionList || this.uniteProductionList.length === 0) {
        return 0;
      }
      return this.uniteProductionList.reduce((total, up) => {
        const quantite = Number(up.quantite_collectee_tonnes) || 0;
        return total + quantite;
      }, 0);
    },
    filteredGroupementList() {
      let filtered = this.groupementList;

      // Appliquer le filtre de recherche
      if (this.groupementSearchKeyword && this.groupementSearchKeyword.trim() !== '') {
        const keyword = this.groupementSearchKeyword.toLowerCase().trim();
        filtered = this.groupementList.filter(grp => {
          return grp.nom && grp.nom.toLowerCase().includes(keyword);
        });
      }

      // Appliquer la pagination
      const start = (this.groupementPagination.page - 1) * this.groupementPagination.limit;
      const end = start + this.groupementPagination.limit;
      return filtered.slice(start, end);
    },
    filteredGroupementListTotal() {
      let filtered = this.groupementList;

      // Appliquer le filtre de recherche pour calculer le total
      if (this.groupementSearchKeyword && this.groupementSearchKeyword.trim() !== '') {
        const keyword = this.groupementSearchKeyword.toLowerCase().trim();
        filtered = this.groupementList.filter(grp => {
          return grp.nom && grp.nom.toLowerCase().includes(keyword);
        });
      }

      return filtered.length;
    },
    groupementPeriodeDisplay() {
      const periode = this.groupementPeriode || {};
      const type = periode.type || '';
      if (!type) {
        return 'Non défini';
      }

      if (type === 'hebdo') {
        const dateReference = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const { start, end, weekNumber } = this.getWeekRange(dateReference);
        const weekLabel = weekNumber ? `Semaine ${weekNumber}` : 'Semaine non définie';
        const formattedStart = this.formatDisplayDate(start);
        const formattedEnd = this.formatDisplayDate(end);
        if (formattedStart && formattedEnd) {
          return `${weekLabel} (${formattedStart} - ${formattedEnd})`;
        }
        return `${weekLabel}`;
      }

      if (type === 'journalier') {
        const referenceDate = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const formattedDate = this.formatDisplayDate(referenceDate);
        if (formattedDate) {
          return `${formattedDate}`;
        }
        return 'Journalier';
      }

      if (type === 'custom') {
        const formattedStart = this.formatDisplayDate(periode.date_debut);
        const formattedEnd = this.formatDisplayDate(periode.date_fin);
        if (formattedStart && formattedEnd) {
          return `Personnalisé - ${formattedStart} - ${formattedEnd}`;
        }
        if (formattedStart || formattedEnd) {
          return `Personnalisé - ${formattedStart || formattedEnd}`;
        }
        return 'Personnalisé';
      }

      if (type === 'campagne') {
        const campagneId = this.getCurrentCampagneId();
        if (campagneId) {
          const campagne = this.campagnes?.find(c => c.id === campagneId);
          const campLabel = campagne?.periode || null;
          if (campLabel) {
            return `${campLabel} (ID ${campagneId})`;
          }
          return `Campagne en cours (ID ${campagneId})`;
        }
        return 'Campagne';
      }

      return type;
    },
    totalQuantiteCollecteeGroupement() {
      if (!this.groupementList || this.groupementList.length === 0) {
        return 0;
      }
      return this.groupementList.reduce((total, grp) => {
        const quantite = Number(grp.quantite_collectee_tonnes) || 0;
        return total + quantite;
      }, 0);
    },
    filteredSCOPSList() {
      let filtered = this.scopsList;

      // Appliquer le filtre de recherche
      if (this.scopsSearchKeyword && this.scopsSearchKeyword.trim() !== '') {
        const keyword = this.scopsSearchKeyword.toLowerCase().trim();
        filtered = this.scopsList.filter(scop => {
          return scop.nom && scop.nom.toLowerCase().includes(keyword);
        });
      }

      // Appliquer la pagination
      const start = (this.scopsPagination.page - 1) * this.scopsPagination.limit;
      const end = start + this.scopsPagination.limit;
      return filtered.slice(start, end);
    },
    filteredSCOPSListTotal() {
      let filtered = this.scopsList;

      // Appliquer le filtre de recherche pour calculer le total
      if (this.scopsSearchKeyword && this.scopsSearchKeyword.trim() !== '') {
        const keyword = this.scopsSearchKeyword.toLowerCase().trim();
        filtered = this.scopsList.filter(scop => {
          return scop.nom && scop.nom.toLowerCase().includes(keyword);
        });
      }

      return filtered.length;
    },
    scopsPeriodeDisplay() {
      const periode = this.scopsPeriode || {};
      const type = periode.type || '';
      if (!type) {
        return 'Non défini';
      }

      if (type === 'hebdo') {
        const dateReference = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const { start, end, weekNumber } = this.getWeekRange(dateReference);
        const weekLabel = weekNumber ? `Semaine ${weekNumber}` : 'Semaine non définie';
        const formattedStart = this.formatDisplayDate(start);
        const formattedEnd = this.formatDisplayDate(end);
        if (formattedStart && formattedEnd) {
          return `${weekLabel} (${formattedStart} - ${formattedEnd})`;
        }
        return `${weekLabel}`;
      }

      if (type === 'journalier') {
        const referenceDate = periode.date_debut || periode.date_fin || this.getTodayISODate();
        const formattedDate = this.formatDisplayDate(referenceDate);
        if (formattedDate) {
          return `${formattedDate}`;
        }
        return 'Journalier';
      }

      if (type === 'custom') {
        const formattedStart = this.formatDisplayDate(periode.date_debut);
        const formattedEnd = this.formatDisplayDate(periode.date_fin);
        if (formattedStart && formattedEnd) {
          return `Personnalisé - ${formattedStart} - ${formattedEnd}`;
        }
        if (formattedStart || formattedEnd) {
          return `Personnalisé - ${formattedStart || formattedEnd}`;
        }
        return 'Personnalisé';
      }

      if (type === 'campagne') {
        const campagneId = this.getCurrentCampagneId();
        if (campagneId) {
          const campagne = this.campagnes?.find(c => c.id === campagneId);
          const campLabel = campagne?.periode || null;
          if (campLabel) {
            return `${campLabel} (ID ${campagneId})`;
          }
          return `Campagne en cours (ID ${campagneId})`;
        }
        return 'Campagne';
      }

      return type;
    },
    totalQuantiteCollecteeSCOPS() {
      if (!this.scopsList || this.scopsList.length === 0) {
        return 0;
      }
      return this.scopsList.reduce((total, scop) => {
        const quantite = Number(scop.quantite_collectee_tonnes) || 0;
        return total + quantite;
      }, 0);
    },
  },
  watch: {
    ciSearchKeyword() {
      // Réinitialiser la page à 1 quand le mot-clé de recherche change
      this.ciPagination.page = 1;
    },
    filteredCIListTotal(newTotal) {
      // Réinitialiser la page si elle dépasse le nombre total de pages
      const totalPages = Math.ceil(newTotal / this.ciPagination.limit);
      if (this.ciPagination.page > totalPages && totalPages > 0) {
        this.ciPagination.page = 1;
      }
    },
    groupementSearchKeyword() {
      // Réinitialiser la page à 1 quand le mot-clé de recherche change
      this.groupementPagination.page = 1;
    },
    filteredGroupementListTotal(newTotal) {
      // Réinitialiser la page si elle dépasse le nombre total de pages
      const totalPages = Math.ceil(newTotal / this.groupementPagination.limit);
      if (this.groupementPagination.page > totalPages && totalPages > 0) {
        this.groupementPagination.page = 1;
      }
    },
    uniteProductionSearchKeyword() {
      // Réinitialiser la page à 1 quand le mot-clé de recherche change
      this.uniteProductionPagination.page = 1;
    },
    filteredUniteProductionListTotal(newTotal) {
      // Réinitialiser la page si elle dépasse le nombre total de pages
      const totalPages = Math.ceil(newTotal / this.uniteProductionPagination.limit);
      if (this.uniteProductionPagination.page > totalPages && totalPages > 0) {
        this.uniteProductionPagination.page = 1;
      }
    },
    scopsSearchKeyword() {
      // Réinitialiser la page à 1 quand le mot-clé de recherche change
      this.scopsPagination.page = 1;
    },
    filteredSCOPSListTotal(newTotal) {
      // Réinitialiser la page si elle dépasse le nombre total de pages
      const totalPages = Math.ceil(newTotal / this.scopsPagination.limit);
      if (this.scopsPagination.page > totalPages && totalPages > 0) {
        this.scopsPagination.page = 1;
      }
    },
  },
  created() {
    this.resetNewRecolte();
    this.resetSearchSac();
    this.getRecoltesList();
    this.getCategoriesRecoltesList();
    this.getCampagnesList();
  },
  methods: {
    checkPermission,
    checkRole,
    isEmptyArray(array){
      if (typeof array !== 'undefined' && array.length === 0) {
        return true;
      }
    },
    handleCloseCampagneagricoleCreateDraw(done) {
      this.$confirm(this.$t('general.closingWarningText'))
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    cancelrecolteForm() {
      this.$refs.CampagneagricoleCreationDrawer.closeDrawer();
    },
    setRecolteStatus(id, statut){

    },
    async filterByCampagne(value){
      if (!this.campagnes || !this.campagnes[value]) {
        return;
      }
      this.query.campagne_agricole_id = this.campagnes[value].id;
      this.getRecoltesList();
    },
    async getCampagnesList() {
      const { data } = await campagneagricoleResource.list(this.queryfiltre);
      this.campagnes = data;

      // Définir une campagne par défaut cohérente pour TOUTE la page (et la modale CI)
      // Règle: prendre la campagne "active" la plus récente (id max) — ex: 39 plutôt que 12.
      if (Array.isArray(this.campagnes) && this.campagnes.length > 0) {
        // Si l’utilisateur a déjà choisi une campagne, ne pas écraser
        if (this.campagneFilter == null) {
          const indexed = this.campagnes.map((c, idx) => ({ c, idx }));
          const active = indexed.filter(x => Number(x.c.is_active) === 1);
          const best = (active.length > 0 ? active : indexed)
            .sort((a, b) => Number(b.c.id) - Number(a.c.id))[0];

          this.campagneFilter = best.idx; // v-model attend un index
          this.query.campagne_agricole_id = best.c.id;
          // Recharger la liste avec la campagne par défaut
          this.getRecoltesList();
        }
      }
    },
    initSearch(){
      this.handleFilterRecoltes();
    },
    async getRecoltesList() {
      this.loading = true;
      const { data, total } = await recolteWebResource.list(this.query);
      this.list = data.reverse();
      this.total = total;
      this.loading = false;
    },
    async getSubCampagneagricolesList(subUrl) {
      this.loading = true;
      const { data } = await recolteResource.sublist('/' + subUrl, this.query);
      this.list = data;
      this.loading = false;
    },
    handleFilterRecoltes() {
      this.query.page = 1;
      this.getRecoltesList();
    },
    handlecreateRecolte() {
      this.editing = false;
      this.resetNewRecolte();
      this.dialogCreateRecolte = true;
      this.$nextTick(() => {
        this.$refs['recolteForm'].clearValidate();
      });
    },
    handleSearchSac() {
      this.editing = false;
      this.resetSearchSac();
      this.sacSearch.dialogSearchSac = true;
    },
    async handleFilterCI() {
      this.ciSearchKeyword = '';
      this.ciPeriode = {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      };
      this.ciPagination = {
        page: 1,
        limit: 50,
      };
      this.dialogFilterCI = true;
      await this.loadCIStatistics();
    },
    async loadCIStatistics() {
      this.loadingCI = true;
      try {
        const campagneId = this.getCurrentCampagneId();

        // Calculer la plage de dates selon le type de période
        const periodeRange = this.getCIPeriodeDateRange();

        // Récupérer les statistiques des CIs depuis l'API backend
        // Si aucune campagne n'est sélectionnée, l'API utilisera la campagne en cours par défaut
        const params = campagneId ? { campagne_agricole_id: Number(campagneId) } : {};

        // Ajouter les paramètres de période si disponibles
        if (periodeRange.date_debut) {
          params.date_debut = periodeRange.date_debut;
        }
        if (periodeRange.date_fin) {
          params.date_fin = periodeRange.date_fin;
        }

        const response = await recolteCIStatsResource.list(params);

        // debug logs retirés

        // Gérer la structure de la réponse
        // L'API retourne { success: true, data: [...] }
        // Resource.list() peut retourner directement response ou response.data selon l'implémentation
        let data = [];
        if (response) {
          if (response.data && Array.isArray(response.data)) {
            // Cas: { success: true, data: [...] }
            data = response.data;
          } else if (Array.isArray(response)) {
            // Cas: réponse directe est un tableau
            data = response;
          }
        }

        // S'assurer que les valeurs numériques sont bien des nombres
        this.ciList = data.map(ci => ({
          ...ci,
          id: Number(ci.id) || 0,
          quantite_collectee_tonnes: Number(ci.quantite_collectee_tonnes) || 0,
          nombre_sacs: Number(ci.nombre_sacs) || 0,
          nombre_collectes: Number(ci.nombre_collectes) || 0,
          superficie_ha: Number(ci.superficie_ha) || 0,
          percentage: Number(ci.percentage) || 0,
        }));

        // debug logs retirés

        // Si la liste est vide, afficher un message informatif
        if (this.ciList.length === 0) {
          this.$message.info('Aucune statistique disponible pour les contrôleurs internes');
        }
      } catch (error) {
        console.error('Erreur lors du chargement des statistiques CI:', error);
        this.$message.error('Erreur lors du chargement des statistiques');
        // S'assurer que la liste est toujours un tableau même en cas d'erreur
        this.ciList = [];
      } finally {
        this.loadingCI = false;
      }
    },
    // IMPORTANT: la modale CI doit utiliser EXACTEMENT la même campagne que la page Récoltes
    // (celle envoyée à /recoltes-web via query.campagne_agricole_id).
    getCurrentCampagneId() {
      const fromQuery = Number(this.query?.campagne_agricole_id);
      if (Number.isFinite(fromQuery) && fromQuery > 0) {
        return fromQuery;
      }
      if (this.campagneFilter != null && Array.isArray(this.campagnes) && this.campagnes[this.campagneFilter]) {
        const id = Number(this.campagnes[this.campagneFilter].id);
        return Number.isFinite(id) && id > 0 ? id : null;
      }
      return null;
    },
    applyCIFilter(ciId) {
      this.selectedCIId = ciId;
      this.query.controleur_id = ciId;
      this.dialogFilterCI = false;
      this.getRecoltesList();
      this.$message.success('Filtre par CI appliqué');
    },
    clearCIFilter() {
      this.selectedCIId = null;
      delete this.query.controleur_id;
      this.dialogFilterCI = false;
      this.getRecoltesList();
      this.$message.info('Filtre CI réinitialisé');
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === '') {
        return '0,00';
      }
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        return '0,00';
      }
      return numValue.toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    async handleFilterSCOPS() {
      this.scopsSearchKeyword = '';
      this.scopsPeriode = {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      };
      this.scopsPagination = {
        page: 1,
        limit: 50,
      };
      this.dialogFilterSCOPS = true;
      await this.loadSCOPSStatistics();
    },
    async loadSCOPSStatistics() {
      this.loadingSCOPS = true;
      try {
        const campagneId = this.getCurrentCampagneId();

        // Calculer la plage de dates selon le type de période
        const periodeRange = this.getSCOPSPeriodeDateRange();

        // Récupérer les statistiques des SCOOPS depuis l'API backend
        const params = campagneId ? { campagne_agricole_id: Number(campagneId) } : {};

        // Ajouter les paramètres de période si disponibles
        if (periodeRange.date_debut) {
          params.date_debut = periodeRange.date_debut;
        }
        if (periodeRange.date_fin) {
          params.date_fin = periodeRange.date_fin;
        }

        const response = await recolteSCOPSStatsResource.list(params);

        // Gérer la structure de la réponse
        let data = [];
        if (response) {
          if (response.data && Array.isArray(response.data)) {
            data = response.data;
          } else if (Array.isArray(response)) {
            data = response;
          }
        }

        // S'assurer que les valeurs numériques sont bien des nombres
        this.scopsList = data.map(scop => ({
          ...scop,
          id: Number(scop.id) || 0,
          quantite_collectee_tonnes: Number(scop.quantite_collectee_tonnes) || 0,
          nombre_sacs: Number(scop.nombre_sacs) || 0,
          nombre_collectes: Number(scop.nombre_collectes) || 0,
          superficie_ha: Number(scop.superficie_ha) || 0,
          percentage: Number(scop.percentage) || 0,
        }));

        // Si la liste est vide, afficher un message informatif
        if (this.scopsList.length === 0) {
          this.$message.info('Aucune statistique disponible pour les SCOOPS');
        }
      } catch (error) {
        console.error('Erreur lors du chargement des statistiques SCOOPS:', error);
        this.$message.error('Erreur lors du chargement des statistiques');
        this.scopsList = [];
      } finally {
        this.loadingSCOPS = false;
      }
    },
    applySCOPSFilter(scoopId) {
      this.selectedSCOPSId = scoopId;
      this.query.scoop_id = scoopId;
      this.dialogFilterSCOPS = false;
      this.getRecoltesList();
      this.$message.success('Filtre par SCOOPS appliqué');
    },
    clearSCOPSFilter() {
      this.selectedSCOPSId = null;
      delete this.query.scoop_id;
      this.dialogFilterSCOPS = false;
      this.getRecoltesList();
      this.$message.info('Filtre SCOOPS réinitialisé');
    },
    handleSCOPSPeriodeChange() {
      const type = this.scopsPeriode.type;
      if (type === 'journalier') {
        this.scopsPeriode.date_debut = this.getTodayISODate();
        this.scopsPeriode.date_fin = null;
      } else if (type === 'hebdo') {
        this.scopsPeriode.date_debut = this.getTodayISODate();
        this.scopsPeriode.date_fin = null;
      } else if (type === 'campagne') {
        this.scopsPeriode.date_debut = null;
        this.scopsPeriode.date_fin = null;
      }
      // Recharger les statistiques avec le nouveau filtre de période
      this.loadSCOPSStatistics();
    },
    handleSCOPSDateChange() {
      // Recharger les statistiques quand les dates changent
      if (this.scopsPeriode.type === 'custom') {
        this.loadSCOPSStatistics();
      }
    },
    getSCOPSPeriodeDateRange() {
      const type = this.scopsPeriode?.type;
      if (!type || type === 'campagne') {
        return { date_debut: null, date_fin: null };
      }

      if (type === 'journalier') {
        const isoDate = this.scopsPeriode.date_debut || this.scopsPeriode.date_fin || this.getTodayISODate();
        if (!isoDate) {
          return { date_debut: null, date_fin: null };
        }
        return { date_debut: isoDate, date_fin: isoDate };
      }

      if (type === 'hebdo') {
        const referenceDate = this.scopsPeriode.date_debut || this.scopsPeriode.date_fin || this.getTodayISODate();
        const { start, end } = this.getWeekRange(referenceDate);
        return { date_debut: start, date_fin: end };
      }

      if (type === 'custom') {
        const start = this.scopsPeriode.date_debut;
        const end = this.scopsPeriode.date_fin;
        if (!start && !end) {
          return { date_debut: null, date_fin: null };
        }
        return {
          date_debut: start || end,
          date_fin: end || start,
        };
      }

      return { date_debut: null, date_fin: null };
    },
    async handleFilterUniteProduction() {
      this.uniteProductionSearchKeyword = '';
      this.uniteProductionPeriode = {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      };
      this.uniteProductionPagination = {
        page: 1,
        limit: 50,
      };
      this.dialogFilterUniteProduction = true;
      await this.loadUniteProductionStatistics();
    },
    async loadUniteProductionStatistics() {
      this.loadingUniteProduction = true;
      try {
        const campagneId = this.getCurrentCampagneId();

        // Calculer la plage de dates selon le type de période
        const periodeRange = this.getUniteProductionPeriodeDateRange();

        // Récupérer les statistiques des Unités de Production depuis l'API backend
        const params = campagneId ? { campagne_agricole_id: Number(campagneId) } : {};

        // Ajouter les paramètres de période si disponibles
        if (periodeRange.date_debut) {
          params.date_debut = periodeRange.date_debut;
        }
        if (periodeRange.date_fin) {
          params.date_fin = periodeRange.date_fin;
        }

        const response = await recolteUniteProductionStatsResource.list(params);

        // Gérer la structure de la réponse
        let data = [];
        if (response) {
          if (response.data && Array.isArray(response.data)) {
            data = response.data;
          } else if (Array.isArray(response)) {
            data = response;
          }
        }

        // S'assurer que les valeurs numériques sont bien des nombres
        this.uniteProductionList = data.map(up => ({
          ...up,
          id: Number(up.id) || 0,
          quantite_collectee_tonnes: Number(up.quantite_collectee_tonnes) || 0,
          nombre_sacs: Number(up.nombre_sacs) || 0,
          nombre_collectes: Number(up.nombre_collectes) || 0,
          superficie_ha: Number(up.superficie_ha) || 0,
          percentage: Number(up.percentage) || 0,
        }));

        // Si la liste est vide, afficher un message informatif
        if (this.uniteProductionList.length === 0) {
          this.$message.info('Aucune statistique disponible pour les unités de production');
        }
      } catch (error) {
        console.error('Erreur lors du chargement des statistiques Unité de Production:', error);
        this.$message.error('Erreur lors du chargement des statistiques');
        this.uniteProductionList = [];
      } finally {
        this.loadingUniteProduction = false;
      }
    },
    applyUniteProductionFilter(uniteProductionId) {
      this.selectedUniteProductionId = uniteProductionId;
      this.query.unite_production_id = uniteProductionId;
      this.dialogFilterUniteProduction = false;
      this.getRecoltesList();
      this.$message.success('Filtre par Unité de Production appliqué');
    },
    clearUniteProductionFilter() {
      this.selectedUniteProductionId = null;
      delete this.query.unite_production_id;
      this.dialogFilterUniteProduction = false;
      this.getRecoltesList();
      this.$message.info('Filtre Unité de Production réinitialisé');
    },
    handleUniteProductionPeriodeChange() {
      const type = this.uniteProductionPeriode.type;
      if (type === 'journalier') {
        this.uniteProductionPeriode.date_debut = this.getTodayISODate();
        this.uniteProductionPeriode.date_fin = null;
      } else if (type === 'hebdo') {
        this.uniteProductionPeriode.date_debut = this.getTodayISODate();
        this.uniteProductionPeriode.date_fin = null;
      } else if (type === 'campagne') {
        this.uniteProductionPeriode.date_debut = null;
        this.uniteProductionPeriode.date_fin = null;
      }
      // Recharger les statistiques avec le nouveau filtre de période
      this.loadUniteProductionStatistics();
    },
    handleUniteProductionDateChange() {
      // Recharger les statistiques quand les dates changent
      if (this.uniteProductionPeriode.type === 'custom') {
        this.loadUniteProductionStatistics();
      }
    },
    getUniteProductionPeriodeDateRange() {
      const type = this.uniteProductionPeriode?.type;
      if (!type || type === 'campagne') {
        return { date_debut: null, date_fin: null };
      }

      if (type === 'journalier') {
        const isoDate = this.uniteProductionPeriode.date_debut || this.uniteProductionPeriode.date_fin || this.getTodayISODate();
        if (!isoDate) {
          return { date_debut: null, date_fin: null };
        }
        return { date_debut: isoDate, date_fin: isoDate };
      }

      if (type === 'hebdo') {
        const referenceDate = this.uniteProductionPeriode.date_debut || this.uniteProductionPeriode.date_fin || this.getTodayISODate();
        const { start, end } = this.getWeekRange(referenceDate);
        return { date_debut: start, date_fin: end };
      }

      if (type === 'custom') {
        const start = this.uniteProductionPeriode.date_debut;
        const end = this.uniteProductionPeriode.date_fin;
        if (!start && !end) {
          return { date_debut: null, date_fin: null };
        }
        return {
          date_debut: start || end,
          date_fin: end || start,
        };
      }

      return { date_debut: null, date_fin: null };
    },
    async handleFilterGroupement() {
      this.groupementSearchKeyword = '';
      this.groupementPeriode = {
        type: 'campagne',
        date_debut: null,
        date_fin: null,
      };
      this.groupementPagination = {
        page: 1,
        limit: 50,
        total: 0,
      };
      this.dialogFilterGroupement = true;
      await this.loadGroupementStatistics();
    },
    async loadGroupementStatistics() {
      this.loadingGroupement = true;
      try {
        const campagneId = this.getCurrentCampagneId();

        // Calculer la plage de dates selon le type de période
        const periodeRange = this.getGroupementPeriodeDateRange();

        // Récupérer les statistiques des Groupements depuis l'API backend
        const params = campagneId ? { campagne_agricole_id: Number(campagneId) } : {};

        // Ajouter les paramètres de période si disponibles
        if (periodeRange.date_debut) {
          params.date_debut = periodeRange.date_debut;
        }
        if (periodeRange.date_fin) {
          params.date_fin = periodeRange.date_fin;
        }

        const response = await recolteGroupementStatsResource.list(params);

        // Gérer la structure de la réponse
        let data = [];
        if (response) {
          if (response.data && Array.isArray(response.data)) {
            data = response.data;
          } else if (Array.isArray(response)) {
            data = response;
          }
        }

        // S'assurer que les valeurs numériques sont bien des nombres
        this.groupementList = data.map(grp => ({
          ...grp,
          id: Number(grp.id) || 0,
          quantite_collectee_tonnes: Number(grp.quantite_collectee_tonnes) || 0,
          nombre_sacs: Number(grp.nombre_sacs) || 0,
          nombre_collectes: Number(grp.nombre_collectes) || 0,
          superficie_ha: Number(grp.superficie_ha) || 0,
          percentage: Number(grp.percentage) || 0,
        }));

        // Si la liste est vide, afficher un message informatif
        if (this.groupementList.length === 0) {
          this.$message.info('Aucune statistique disponible pour les groupements');
        }
      } catch (error) {
        console.error('Erreur lors du chargement des statistiques Groupement:', error);
        this.$message.error('Erreur lors du chargement des statistiques');
        this.groupementList = [];
      } finally {
        this.loadingGroupement = false;
      }
    },
    applyGroupementFilter(groupementId) {
      this.selectedGroupementId = groupementId;
      this.query.groupement_id = groupementId;
      this.dialogFilterGroupement = false;
      this.getRecoltesList();
      this.$message.success('Filtre par Groupement appliqué');
    },
    clearGroupementFilter() {
      this.selectedGroupementId = null;
      delete this.query.groupement_id;
      this.dialogFilterGroupement = false;
      this.getRecoltesList();
      this.$message.info('Filtre Groupement réinitialisé');
    },
    handleGroupementPeriodeChange() {
      const type = this.groupementPeriode.type;
      if (type === 'journalier') {
        this.groupementPeriode.date_debut = this.getTodayISODate();
        this.groupementPeriode.date_fin = null;
      } else if (type === 'hebdo') {
        this.groupementPeriode.date_debut = this.getTodayISODate();
        this.groupementPeriode.date_fin = null;
      } else if (type === 'campagne') {
        this.groupementPeriode.date_debut = null;
        this.groupementPeriode.date_fin = null;
      }
      // Recharger les statistiques avec le nouveau filtre de période
      this.loadGroupementStatistics();
    },
    handleGroupementDateChange() {
      // Recharger les statistiques quand les dates changent
      if (this.groupementPeriode.type === 'custom') {
        this.loadGroupementStatistics();
      }
    },
    getGroupementPeriodeDateRange() {
      const type = this.groupementPeriode?.type;
      if (!type || type === 'campagne') {
        return { date_debut: null, date_fin: null };
      }

      if (type === 'journalier') {
        const isoDate = this.groupementPeriode.date_debut || this.groupementPeriode.date_fin || this.getTodayISODate();
        if (!isoDate) {
          return { date_debut: null, date_fin: null };
        }
        return { date_debut: isoDate, date_fin: isoDate };
      }

      if (type === 'hebdo') {
        const referenceDate = this.groupementPeriode.date_debut || this.groupementPeriode.date_fin || this.getTodayISODate();
        const { start, end } = this.getWeekRange(referenceDate);
        return { date_debut: start, date_fin: end };
      }

      if (type === 'custom') {
        const start = this.groupementPeriode.date_debut;
        const end = this.groupementPeriode.date_fin;
        if (!start && !end) {
          return { date_debut: null, date_fin: null };
        }
        return {
          date_debut: start || end,
          date_fin: end || start,
        };
      }

      return { date_debut: null, date_fin: null };
    },
    handleCIPeriodeChange() {
      const type = this.ciPeriode.type;
      if (type === 'journalier') {
        // Pour journalier, utiliser la date du jour
        this.ciPeriode.date_debut = this.getTodayISODate();
        this.ciPeriode.date_fin = null;
      } else if (type === 'hebdo') {
        // Pour hebdo, utiliser la date du jour comme référence pour calculer la semaine
        this.ciPeriode.date_debut = this.getTodayISODate();
        this.ciPeriode.date_fin = null;
      } else if (type === 'campagne') {
        // Pour campagne, pas de filtre de date
        this.ciPeriode.date_debut = null;
        this.ciPeriode.date_fin = null;
      }
      // Recharger les statistiques avec le nouveau filtre de période
      this.loadCIStatistics();
    },
    handleCIDateChange() {
      // Recharger les statistiques quand les dates changent
      if (this.ciPeriode.type === 'custom') {
        this.loadCIStatistics();
      }
    },
    getCIPeriodeDateRange() {
      const type = this.ciPeriode?.type;
      if (!type || type === 'campagne') {
        return { date_debut: null, date_fin: null };
      }

      if (type === 'journalier') {
        const isoDate = this.ciPeriode.date_debut || this.ciPeriode.date_fin || this.getTodayISODate();
        if (!isoDate) {
          return { date_debut: null, date_fin: null };
        }
        return { date_debut: isoDate, date_fin: isoDate };
      }

      if (type === 'hebdo') {
        const referenceDate = this.ciPeriode.date_debut || this.ciPeriode.date_fin || this.getTodayISODate();
        const { start, end } = this.getWeekRange(referenceDate);
        return { date_debut: start, date_fin: end };
      }

      if (type === 'custom') {
        const start = this.ciPeriode.date_debut;
        const end = this.ciPeriode.date_fin;
        if (!start && !end) {
          return { date_debut: null, date_fin: null };
        }
        return {
          date_debut: start || end,
          date_fin: end || start,
        };
      }

      return { date_debut: null, date_fin: null };
    },
    getTodayISODate() {
      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatDisplayDate(dateStr) {
      if (!dateStr) {
        return null;
      }
      try {
        const date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          return null;
        }
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
      } catch (e) {
        return null;
      }
    },
    getWeekRange(dateStr) {
      if (!dateStr) {
        const today = this.getTodayISODate();
        dateStr = today;
      }

      try {
        let date = new Date(dateStr);
        if (isNaN(date.getTime())) {
          const today = this.getTodayISODate();
          dateStr = today;
          date = new Date(dateStr);
        }

        // Obtenir le lundi de la semaine (ISO week)
        const day = date.getDay();
        const diff = date.getDate() - day + (day === 0 ? -6 : 1); // Ajuster pour lundi = 1
        const monday = new Date(date.setDate(diff));
        monday.setHours(0, 0, 0, 0);

        // Obtenir le dimanche de la semaine
        const sunday = new Date(monday);
        sunday.setDate(monday.getDate() + 6);
        sunday.setHours(23, 59, 59, 999);

        // Calculer le numéro de semaine ISO
        const startOfYear = new Date(monday.getFullYear(), 0, 1);
        const pastDaysOfYear = (monday - startOfYear) / 86400000;
        const weekNumber = Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);

        const formatDate = (d) => {
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, '0');
          const day = String(d.getDate()).padStart(2, '0');
          return `${year}-${month}-${day}`;
        };

        return {
          start: formatDate(monday),
          end: formatDate(sunday),
          weekNumber,
        };
      } catch (e) {
        const today = this.getTodayISODate();
        return {
          start: today,
          end: today,
          weekNumber: null,
        };
      }
    },
    async getSacDetail() {
      // this.loading = true;
      if (!this.sacSearch.keyword.code) {
        this.sacSearch.sacSearchMessage = 'Veuillez saisir un code';
        this.sacSearch.sacSearchError = true;
      } else {
        const data = await sacResource.getSacInfo(this.sacSearch.keyword);
        if (!data.success) {
          this.sacSearch.sacSearchMessage = data.message;
          this.sacSearch.sacSearchError = true;
        } else {
          this.currentSac = data.data;
          this.sacSearch.dialogSearchSac = false;
          this.sacSearch.dialogSacInfo = true;
          this.sacSearch.sacSearchError = false;
        }
      }
    },
    getRecolteLink(id){
      // debug log retiré
      this.$router.push({ path: '/recoltes/' + id });
    },
    getProducteurLink(id){
      // debug log retiré
      this.$router.push({ path: '/producteurs/' + id });
    },
    getParcelleLink(id){
      // debug log retiré
      this.$router.push({ path: '/parcelles/' + id });
    },
    getLotLink(id){
      this.$router.push({ path: '/lots/' + id });
    },
    getGroupementLink(id){
      // debug log retiré
      this.$router.push({ path: '/groupement/' + id });
    },
    getUniteProductionLink(id){
      // debug log retiré
      this.$router.push({ path: '/uniteProduction/' + id });
    },

    handleEditRecolte(id){
      this.editing = true;
      this.resetNewRecolte();
      this.currentRecolte = this.list.find(abonne => abonne.id === id);
      this.dialogCreateRecolte = true;
      this.$nextTick(() => {
        this.$refs['recolteForm'].clearValidate();
      });
    },
    handleDeleteRecolte(id, visible, libelle) {
      // debug log retiré
      this.$confirm(this.$t('recolte.deleteWarn') + ' ' + libelle + '. ' + this.$t('general.deleteContinue'), 'Warning', {
        confirmButtonText: 'Oui',
        cancelButtonText: this.$t('general.cancel'),
        type: 'warning',
      }).then(() => {
        // debug log retiré
        if (!visible && (checkRole(['admin']) || checkPermission(['supprimer collecte']))) {
          // debug log retiré
          this.$swal({
            title: this.$t('general.SureRecolte'),
            text: this.$t('general.irrversibleMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('general.ouiSupprimer'),
          }).then((result) => {
            if (result.isConfirmed) {
              recolteResource.destroy(id).then(response => {
                this.$message({
                  type: 'success',
                  message: this.$t('recolte.suppressionEffectue'),
                });
                this.initSearch();
              }).catch(error => {
                console.error(error);
              });
            }
          });
        } else {
          this.setRecolteStatus(id, 'visible');
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: this.$t('general.suppressionAnnule'),
        });
      });
    },
    createRecolte() {
      this.$refs['recolteForm'].validate((valid) => {
        if (valid) {
          this.recolteCreating = true;
          recolteResource
            .store(this.currentRecolte)
            .then(async(response) => {
              this.$message({
                message: this.$t('recolte.NewRecolte') + ' ' + this.currentRecolte.libelle + ' ' + this.$t('recolte.iscreatedSuccessfully'),
                type: 'success',
                duration: 5 * 1000,
              });
              this.currentRecolteId = response.data.id;
              this.resetNewRecolte();
              this.dialogCreateRecolte = false;
              this.handleFilterRecoltes();
            })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              this.recolteCreating = false;
            });
        } else {
          // debug log retiré
          return false;
        }
      });
    },
    resetNewRecolte() {
      this.currentRecolte = {
        libelle: '',
        description: '',
      };
    },
    resetSearchSac() {
      this.sacSearch.keyword = {
        code: '',
      };
    },
    // createRecolte() {
    //   this.$refs['recolteForm'].validate((valid) => {
    //     if (valid && this.ci.length > 0) {
    //       this.recolteCreating = true;
    //       this.currentRecolte.ci = this.ci !== 'audit';
    //       recolteResource
    //         .store(this.currentRecolte)
    //         .then(async(response) => {
    //           this.$message({
    //             message: this.$t('recolte.NewRecolte') + ' ' + this.currentRecolte.libelle + ' ' + this.$t('recolte.iscreatedSuccessfully'),
    //             type: 'success',
    //             duration: 5 * 1000,
    //           });
    //           console.log('LA NOULEEE : ', response.data.id);
    //           this.currentRecolte.recolte_id = response.data.id;
    //           this.resetNewRecolte();
    //           this.dialogCreateRecolte = false;
    //           this.handleFilterRecoltes();
    //         })
    //         .catch(error => {
    //           console.log(error);
    //         })
    //         .finally(() => {
    //           this.recolteCreating = false;
    //           this.dialogCreateRecolte = false;
    //           this.getCategoriesRecoltesList();
    //         });
    //     } else {
    //       this.$message({
    //         type: 'info',
    //         message: this.$t('general.formInvalid'),
    //       });
    //       return false;
    //     }
    //   });
    // },
    updateRecolte() {
      this.$refs['recolteForm'].validate((valid) => {
        if (valid) {
          this.recolteCreating = true;
          recolteResource.update(this.currentRecolte.id, this.currentRecolte).then(response => {
            this.resetNewRecolte();
            this.handleFilterRecoltes();
            this.$message({
              message: this.$t('recolte.isupdatedSuccessfully'),
              type: 'success',
              duration: 5 * 1000,
            });
            this.dialogCreateRecolte = false;
            this.editing = false;
          })
            .catch(error => {
              console.error(error);
            })
            .finally(() => {
              this.recolteCreating = false;
            });
        } else {
          // debug log retiré
          return false;
        }
      });
    },
    // resetNewRecolte() {
    //   this.currentRecolte = {
    //     libelle: '',
    //     recolte_id: null,
    //   };
    // },
    handleDownload() {
      this.downloading = true;
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = ['ID', this.$t('general.code'), this.$t('recolte.libelle')];
        const filterVal = ['id', 'code', 'libelle'];
        const data = this.formatJson(filterVal, this.list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'Liste des recoltes AAS_' + moment().format('DD-MM-YYYY_hh-mm'),
        });
        this.downloading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    handleRemove(file, fileList) {
      // debug log retiré
    },
    handlePreview(file) {
      // debug log retiré
    },
    onChange(file, fileList){
      var a = this.fileList;
      a.push({ name: file.name, url: file.url });
      // console.log('onChange begin');
      this.fileList = a;
      // console.log(this.fileList);
      // console.log('onChange end');
    },
    async getCategoriesRecoltesList() {
      const { data } = await recolteWebResource.list(this.query);
      this.recoltes = data;
      const _reg = [];
      data.forEach(recolte => {
        _reg[recolte.id] = recolte.libelle;
      });
      this.libelleRecolte = _reg;
    },
  },
};
</script>

<style lang="scss" scoped>
.ligne {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
}
.bouton {
  height: 40px;
  width: 40px;
  margin-right: auto;
  margin-left: 15px;
  margin-top: 10px;
}
.edit-input {
  padding-right: 100px;
}
.cancel-btn {
  position: absolute;
  right: 15px;
  top: 10px;
}
.dialog-footer {
  text-align: left;
  padding-top: 0;
  margin-left: 150px;
}
.app-container {
  flex: 1;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  .block {
    float: left;
    min-width: 250px;
  }
  .clear-left {
    clear: left;
  }
}
</style>
